module.exports = __webpack_public_path__ + "static/media/about.eb258706.png";